import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="scale(1.1 1.1)"
      d="M11.1298 7.42345C11.6856 6.86934 12.4444 6.54647 13.2619 6.54647H16.8212L14.1206 12.1318L14.1205 12.1319C13.5394 13.3342 12.2911 14.12 10.9467 14.12H7.68907L8.10313 13.2679H9.60213C12.3583 13.2679 14.603 11.0231 14.603 8.267V7.42345H13.7595H11.1298ZM9.06841 7.42345C9.87456 5.84809 11.4827 4.85938 13.2619 4.85938H18.166H19.5109L18.9255 6.07012L15.6395 12.8661L15.6394 12.8662C14.7766 14.6512 12.9381 15.8071 10.9467 15.8071H6.34131H4.99355L5.58259 14.5949L6.2274 13.2679H5.64396H1.53642H0.692871V12.4243V11.802C0.692871 10.6927 1.09591 9.71273 1.72659 8.93189L1.75906 8.89168L1.7962 8.85574C2.71536 7.96624 3.94288 7.42345 5.29544 7.42345H5.66885H9.06841ZM7.04719 11.5808H5.64396H2.38861C2.43396 11.0035 2.65595 10.4809 3.00701 10.0323C3.6262 9.45001 4.42522 9.11055 5.29544 9.11055H5.66885H8.24751L7.04719 11.5808ZM8.92292 11.5808L10.1232 9.11055H12.8067C12.4318 10.529 11.1352 11.5808 9.60213 11.5808H8.92292Z"
      fill={fill}
    />
  </g>
);

export default Icon;
